/**
 * Utility functions for date formatting and conversion.
 * Extracted from JobDetailsPage.js for reuse.
 */

/**
 * Get today's date as a 'YYYY-MM-DD' string in local timezone.
 * @param {Date} [date=new Date()] - Optional date to format.
 * @returns {string} Date string in 'YYYY-MM-DD' format.
 */
export const getLocalDateString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Convert Firestore Timestamp, Date object, or date string to 'YYYY-MM-DD' string.
 * @param {object|Date|string|null} timestamp - The date value to format.
 * @returns {string} Date string in 'YYYY-MM-DD' format, or empty string if invalid.
 */
export const formatDateToInput = (timestamp) => {
  if (!timestamp) return '';
  let date;
  if (typeof timestamp.toDate === 'function') {
    date = timestamp.toDate(); // Firestore Timestamp
  } else if (timestamp instanceof Date) {
    date = timestamp; // Date object
  } else if (typeof timestamp._seconds === 'number') {
    date = new Date(timestamp._seconds * 1000); // Serialized Timestamp
  } else if (typeof timestamp === 'string') {
    // Try parsing string (e.g., from completionDate)
    try {
      date = new Date(timestamp);
      if (isNaN(date)) return ''; // Invalid date string
    } catch {
      return '';
    }
  } else {
    return ''; // Not a recognizable date format
  }

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};
